import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Container } from "react-bootstrap";

import productType from "../../../../redux/actions/product/productType";

import { calculatePageSize } from "../../../../libs/pagingDetail";
import useFilter from "../../../../hooks/useFilter";

import PaginationComponent from "../../../../components/public/pagination";
import UserResponsiveHeaderComponent from "../../../../components/private/user/userReponsiveHeader";

import SimsComponent from "../../../../components/public/sims";

export default function ExperimentTabComponent({
  productDetail,
  filterParams,
  getSimsMethod,
}) {
  const { onChange, filterState } = useFilter();
  const dispatch = useDispatch();
  const location = useLocation();
  const search = location.search;
  const [currentPage, setCurrentPage] = useState(filterState["page"] || 1);

  useEffect(() => {
    getSimsMethod && getSimsMethod();
  }, [currentPage]);
  
  useEffect(() => {
    if (filterParams)
      dispatch({
        type: productType.START_FETCHING_PRODUCT,
        search: filterParams
          ? `?${filterParams}&page_size=${
              process.env.REACT_APP_PROFILE_PAGE_SIZE
            }&page=${filterState["page"] || 1}`
          : `?page_size=${process.env.REACT_APP_PROFILE_PAGE_SIZE}&page=${
              filterState["page"] || 1
            }`,
      });
  }, [search]);

  let noSimsErrorMessage = "";
  if (productDetail.product && !productDetail.product?.results?.length) {
    if (filterState["tab"] === "my_favourite") {
      noSimsErrorMessage = "به هیچ آزمایشی تا کنون علاقه نداشته‌اید!";
    } else {
      noSimsErrorMessage = "هیچ آزمایشی خریداری نشده است.";
    }
  }

  return (
    <Container>
      <UserResponsiveHeaderComponent title={document.title} />
      <SimsComponent
        simsData={productDetail}
        isProfile
        noSimsErrorMessage={noSimsErrorMessage}
      />
      {productDetail.product && (
        <PaginationComponent
          pageNumber={calculatePageSize(
            productDetail.product.count,
            process.env.REACT_APP_PROFILE_PAGE_SIZE
          )}
          currentPage={filterState["page"] || 1}
          handleChangePage={(e, value) => {
            onChange("page", value);
            setCurrentPage(value)
          }}
          className="mt-5"
          defaulPage={1}
        />
      )}
    </Container>
  );
}
